import { z } from 'zod';

export const DEFAULT_MODULE: string = 'core';

export const AuditEntryZod = z.object({
  remoteAddress: z.string().optional(),
  user: z.string().optional(),
  date: z.coerce.date().optional(),
  method: z.string().optional(),
  url: z.string().optional(),
  http: z.string().optional(),
  status: z.string().optional(),
  response: z.string().optional(),
  referrer: z.string().optional(),
  userAgent: z.string().optional(),
  variables: z.object({}).optional(),
  extensions: z.object({}).optional(),
  operationName: z.string().optional(),
  query: z.object({}).optional(),
  module: z.string().default(DEFAULT_MODULE),
});

export type AuditEntry = z.infer<typeof AuditEntryZod>;

export const AuditFilterZod = z.object({
  from: z.date().optional(),
  to: z.date().optional(),
  methods: z.array(z.string()).optional(),
});

export type AuditFilter = z.infer<typeof AuditFilterZod>;

export interface AuditWriter {
  write(entry: AuditEntry, callback?: (resp: string | null) => void): void;
  delete(filter: AuditFilter): Promise<number>;
}
